import {
  GET_ADDITIONAL_FIELDS,
  GET_ADDITIONAL_FIELD,
  CREATE_ADDITIONAL_FIELD,
  CREATE_ADDITIONAL_FIELDS_SUCCESS,
  SET_ADDITIONAL_FIELDS,
  SET_ADDITIONAL_FIELD,
  SET_ADDITIONAL_FIELDS_STATUS,
  RESET_ADDITIONAL_FIELDS,
  ACTIVATE_ADDITIONAL_FIELD,
  ACTIVATE_ADDITIONAL_FIELD_SUCCESS,
  EDIT_ADDITIONAL_FIELD,
  EDIT_ADDITIONAL_FIELD_SUCCESS,
  RESET_ERROR,
  API_ERROR,
} from './actionTypes'

export const getAdditionalFields = (page, qnt, value, type) => {
  return {
    type: GET_ADDITIONAL_FIELDS,
    payload: { page, qnt, value, type },
  };
};

export const getAdditionalField = (id, isForm) => {
  return {
    type: GET_ADDITIONAL_FIELD,
    payload: { id, isForm },
  };
};

export const createAdditionalField = (data) => {
  return {
    type: CREATE_ADDITIONAL_FIELD,
    payload: { data },
  };
}

export const createAdditionalFieldSuccess = (message) => {
  return {
    type: CREATE_ADDITIONAL_FIELDS_SUCCESS,
    payload: { message },
  };
}

export const setAdditionalFields = (data, qtdDefault) => {
  const maxPage = qtdDefault ? Math.ceil(data.total / qtdDefault) : 1;
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_ADDITIONAL_FIELDS,
    payload: { ...data, paging },
  };
};

export const setAdditionalField = ({data, skills}) => {
  return {
    type: SET_ADDITIONAL_FIELD,
    payload: { data, skills },
  };
};


export const setAdditionalFieldsStatus = (status) => {
  return {
    type: SET_ADDITIONAL_FIELDS_STATUS,
    payload: { status },
  };
}

export const resetAdditionalFields = () => {
  return {
    type: RESET_ADDITIONAL_FIELDS,
    payload: {},
  };
};

export const activateAdditionalField = (id, active) => {
  return {
    type: ACTIVATE_ADDITIONAL_FIELD,
    payload: { id, active },
  };
};

export const activateAdditionalFieldSuccess = (message) => {
  return {
    type: ACTIVATE_ADDITIONAL_FIELD_SUCCESS,
    payload: { message },
  };
};

export const editAdditionalField = (id, values) => {
  return {
    type: EDIT_ADDITIONAL_FIELD,
    payload: { id, values },
  };
};

export const editAdditionalFieldSuccess = (message) => {
  return {
    type: EDIT_ADDITIONAL_FIELD_SUCCESS,
    payload: { message },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};